// eslint-disable-next-line boundaries/no-unknown-files
import { createApi } from '@reduxjs/toolkit/query/react';
import reducerPath from '../../../../app/reducerPath';
// eslint-disable-next-line boundaries/element-types
import createHeadRequest from '../../../../shared/http/createHeadRequest';
// eslint-disable-next-line boundaries/element-types
import checkStatus from '../../../../shared/http/checkStatus';
// eslint-disable-next-line boundaries/element-types
import HttpMethods from '../../../../shared/api/HttpMethods';
// eslint-disable-next-line import/no-named-as-default
import vehicleFromDtoService from '../services/data/vehicle-from-dto.service';
import config from '../../../../shared/api/config';
// eslint-disable-next-line boundaries/element-types
import baseQueryWithReAuth from '../../../baseQueryWithReAuth/baseQueryWithReAuth';

// Описываем методы обращения к беку
export const vehicleApi = createApi({
  reducerPath: `${reducerPath.vehicle}/api`,
  tagTypes: ['TAG'],
  baseQuery: (...arg) => baseQueryWithReAuth(...arg, `${config.baseUrl}/vehicles`),
  endpoints: (builder) => ({
    getVehiclesResource: builder.query({
      query: ({ params }) => ({
        ...createHeadRequest({ url: ``, method: HttpMethods.GET }),
        params,
        validateStatus: checkStatus,
      }),
      transformResponse: vehicleFromDtoService,
    }),
    getVehicleId: builder.query({
      query: ({ id }) => ({
        ...createHeadRequest({ url: `/${id}`, method: HttpMethods.GET }),
        validateStatus: checkStatus,
      }),
      transformResponse: vehicleFromDtoService,
    }),
    getVehicleIdResourceQuery: builder.query({
      query: ({ id }) => ({
        ...createHeadRequest({ url: `/${id}`, method: HttpMethods.GET }),
        validateStatus: checkStatus,
      }),
      transformResponse: vehicleFromDtoService,
    }),

    postVehicle: builder.mutation({
      query: (body) => ({
        url: ``,
        method: HttpMethods.POST,
        body,
        validateStatus: checkStatus,
      }),
      transformResponse: vehicleFromDtoService,
      invalidatesTags: ['VehicleIcon'],
    }),

    putVehicle: builder.mutation({
      query: (body) => ({
        url: `/${body.vehicleId ?? ''}`,
        method: HttpMethods.PUT,
        body,
        validateStatus: checkStatus,
      }),
      transformResponse: vehicleFromDtoService,
      invalidatesTags: ['VehicleIcon'],
    }),

    getVehicleModelIcon: builder.query({
      async queryFn({ vehicleCustomIcon, vehicleModelId, token }) {
        try {
          if (!vehicleModelId || !token) return { data: null };

          const params = new URLSearchParams({ access_token: token }).toString();
          const commonIcon = `${config.baseUrl}/vehicle-models/${vehicleModelId}/icon`;
          const url = `${vehicleCustomIcon || commonIcon}?${params}`;

          const res = await fetch(url);
          if (!res.ok) {
            return { error: { status: res.status, data: await res.text() } };
          }

          const blob = await res.blob();
          const base64 = await new Promise((resolve) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.readAsDataURL(blob);
          });

          return { data: base64 };
        } catch (err) {
          return { error: { status: 'CUSTOM_ERROR', data: err?.message } };
        }
      },
      providesTags: ['VehicleIcon'],
    }),
  }),
});

export const {
  useGetVehicleIdQuery,
  useLazyGetVehicleIdQuery,
  useGetVehiclesResourceQuery,
  useLazyGetVehiclesResourceQuery,
  useGetVehicleIdResourceQueryQuery,
  useGetVehicleModelIconQuery,
  usePostVehicleMutation,
  usePutVehicleMutation,
} = vehicleApi;
